<i18n>
{
  "pe": {
    "close":"Cerrar",
    "title":"Agregar Broker",
    "name":"Nombre",
    "identification":"DNI",
    "phone":"Telefono",
    "errorMessage":"Completa el formulario",
    "brokerExist":"Este Broker ya existe",
    "create":"Crear",
    "reset":"Limpiar",
    "messageCreatedBroker":"El Broker fue creado"
    },
  "cl": {
    "close":"Cerrar",
    "title":"Agregar Broker",
    "name":"Nombre",
    "identification":"DNI",
    "phone":"Telefono",
    "errorMessage":"Completa el formulario",
    "brokerExist":"Este Broker ya existe",
    "create":"Crear",
    "reset":"Limpiar",
    "messageCreatedBroker":"El Broker fue creado"

  },
  "br": {
    "close":"Fechar",
    "title":"Dados Broker",
    "name":"Nome",
    "identification":"CNPJ",
    "phone":"Telefone",
    "errorMessage":"Complete a forma",
    "brokerExist":"Este corretor já existe",
    "create":"Crear",
    "reset":"Redefinir",
    "messageCreatedBroker":"O Broker foi criado"
  }
}
</i18n>
<template>
  <form @submit.prevent>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('title') }}</p>
        <button type="button" class="delete" @click="close()" />
      </header>
      <div v-if="isLoading" class="spinner">
        <Spinner v-if="isLoading " class="spinner2" />
      </div>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <section class="modal-card-body">
          <b-field>
            <validationInput
              v-model="values.email"
              rules="required|email"
              icon-pack="fas"
              icon="envelope"
              type="email"
              label="Email" />
          </b-field>

          <b-field>
            <validationInput
              v-model="values.name"
              rules="required"
              icon-pack="fas"
              icon="user"
              :label="$t('name')" />
          </b-field>

          <b-field>
            <validationInput
              v-model="values.idNumber"
              icon-pack="fas"
              icon="image-portrait"
              rules="required|cnpj_id"
              :label="$t('identification')" />
          </b-field>

          <b-field>
            <validationInput
              v-model="values.phone"
              icon="fa-solid fa-phone"
              rules="phoneBr"
              :icon-right="iconRight"
              :label="$t('phone')" />
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="handleSubmit(submit)">
            <span class="icon is-small">
              <i class="fas fa-check" />
            </span>
            <span>{{ $t('create') }}</span>
          </button>

          <button class="button" @click="resetForm">
            <span class="icon is-small">
              <i class="fas fa-redo" />
            </span>
            <span>{{ $t('reset') }}</span>
          </button>
          <b-button :label="$t('close')" @click="close()" />
        </footer>
      </ValidationObserver>
    </div>
  </form>
</template>
<script>
import { ValidationObserver } from 'vee-validate';
import { addBroker } from '@/application/services/api-clients/brokers';
import Spinner from '@/ui/components/Spinner.vue';
import validationInput from '../input/validationInput.vue';

export default {
  name: 'CreateBrokerForm',
  components: {
    Spinner,
    ValidationObserver,
    validationInput
  },
  data() {
    return {
      iconRight: 'none',
      isLoading: false,
      values: {
        idNumber: '',
        name: '',
        email: '',
        phone: ''
      },
      executiveName: this.$store.state.currentUser.user.name,
      executiveId: this.$store.state.currentUser.user._id
    };
  },
  watch: {
    values: {
      deep: true,
      handler(val) {
        if (val.phone.length > 0 && val.phone.length < 14) {
          this.iconRight = '';
        } else {
          this.iconRight = 'none';
        }
      }
    }
  },

  methods: {
    close() {
      this.$router.go(1);
      this.$emit('close');
    },

    errorAlert(message, type = 'is-danger') {
      this.$buefy.toast.open({
        message,
        position: 'is-top',
        type
      });
    },

    async submit() {
      this.isLoading = true;
      const NewInformation = {
        idNumber: this.values.idNumber,
        name: this.values.name,
        phone: this.values.phone === '' ? '+552255555555' : this.values.phone,
        email: this.values.email,
        status: 'ACTIVE',
        prospectsList: [],
        assignedCommercialAnalyst: {
          _id: this.executiveId,
          name: this.executiveName
        },
        brokerSource: { origin: 'commercial-manager' }
      };
      await this.addBroker(NewInformation);
      this.resetForm();
    },

    async resetForm() {
      this.values = {
        idNumber: '',
        name: '',
        email: '',
        phone: ''
      };
      await this.$nextTick();
      this.$refs.observer.reset();
      this.isLoading = false;
    },

    async addBroker(createBrokerInfomation) {
      try {
        const { brokerId } = await addBroker(createBrokerInfomation);
        if (brokerId) {
          this.errorAlert(this.$t('messageCreatedBroker'), 'is-primary');
        } else {
          this.errorAlert(this.$t('brokerExist'));
        }
      } catch (_error) {
        this.errorAlert(this.$t('errorMessage'));
      }
    }
  }
};
</script>

<style scoped>
.spinner{
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background-color:#00000080;
}
.spinner2{
  margin-top: 50%;
}
.modal-card{
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0,0.7);
}
.modal-card-title{
  color: white
  }

.modal-card-head{
  background-color:#00CCD1;
}
.modal-card-head p{
  font-weight: bold;
}

.modal-card-foot{
  background-color: #fff;
  border: none;
}

.button{
  transition: 0.5s all;

}
.button:hover{
  transform: translateY(-3px);
  /* box-shadow: 0 5px 15px 0 rgba(0, 0, 0,0.5); */
}

</style>
